import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/platforms';

export default function CategoryNav() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all duration-200 whitespace-nowrap ${
            slug === cat.slug
              ? 'bg-primary-500 text-background-50 font-medium'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
          }`}
        >
          <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
          {cat.name}
          <span className={`text-xs ${slug === cat.slug ? 'text-background-50/80' : 'text-foreground-400'}`}>
            {cat.count}
          </span>
        </Link>
      ))}
    </div>
  );
}